(() => {
  const main = document.querySelector('#MainContent[data-template]');

  if (!main || main.dataset.template === 'index') return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const isDesignMode = Boolean(window.Shopify?.designMode);
  let refreshFrame;

  function prepareElement(element) {
    if (!element) return;

    element.classList.remove(
      'scroll-trigger',
      'scroll-trigger--offscreen',
      'animate--fade-in',
      'animate--slide-in',
    );
    element.removeAttribute('data-cascade');
  }

  function addAos(element, animation, options = {}) {
    if (!element || element.dataset.aos) return;

    prepareElement(element);
    element.dataset.aos = animation;
    element.dataset.aosOffset = String(options.offset ?? 65);
    element.style.setProperty('--vag-motion-duration', `${options.duration || 700}ms`);
    element.style.setProperty('--vag-motion-delay', `${options.delay || 0}ms`);
  }

  function annotateCollection(root = document) {
    const collection = root.querySelector('collection-component.collection-page-design');
    if (!collection) return;

    const banner = document.querySelector('.template-collection .collection-hero, #MainContent[data-template="collection"] .banner');
    prepareElement(banner);
    prepareElement(banner?.querySelector('.banner__content, .collection-hero__inner'));
    addAos(banner?.querySelector('.banner__media, .collection-hero__image-container'), 'vag-collection-media', {
      duration: 900,
      offset: 0,
    });
    addAos(banner?.querySelector('.banner__box, .collection-hero__text-wrapper'), 'vag-collection-copy', {
      duration: 720,
      delay: 100,
      offset: 0,
    });

    addAos(collection.querySelector('.facets-vertical-sort'), 'vag-toolbar', { duration: 620, offset: 30 });
    if (window.innerWidth >= 750) {
      addAos(collection.querySelector('.facets-wrapper'), 'vag-facets', { duration: 680, delay: 60, offset: 45 });
    } else {
      prepareElement(collection.querySelector('.facets-wrapper'));
    }
    prepareElement(collection.querySelector('#ProductGridContainer'));

    collection.querySelectorAll('#product-grid > .grid__item').forEach((card, index) => {
      addAos(card, 'vag-card-rise', {
        duration: 680,
        delay: Math.min((index % 6) * 55, 275),
        offset: 55,
      });
    });
  }

  function annotateProduct(root = document) {
    const product = root.querySelector('[id^="MainProduct-"] .product');
    if (!product) return;

    prepareElement(product.querySelector('.product__info-wrapper'));
    addAos(product.querySelector('.product__media-wrapper'), 'vag-product-media', {
      duration: 820,
      offset: 20,
    });

    product.querySelectorAll('.thumbnail-list__item, .product__media-list > .product__media-item').forEach((item, index) => {
      if (index === 0 && item.matches('.product__media-list > .product__media-item')) return;
      addAos(item, 'vag-product-thumb', {
        duration: 520,
        delay: Math.min(index * 45, 225),
        offset: 15,
      });
    });

    const details = product.querySelectorAll(
      '.product__info-container > .product__title, .product__info-container > .product-rating, .product__info-container > [id^="price-"], .product__info-container > .product__text, .product__info-container > .product__inventory, .product__info-container > .product-feature-grid, .product__info-container > variant-selects, .product__info-container > variant-radios',
    );
    details.forEach((item, index) => {
      addAos(item, 'vag-product-detail', {
        duration: 620,
        delay: Math.min(index * 65, 260),
        offset: 20,
      });
    });

    const infoContainer = product.querySelector('.product__info-container');
    const actionElements = infoContainer
      ? [
          ...infoContainer.querySelectorAll(
            ':scope > [id^="Quantity-Form-"], :scope > .product__accordion, :scope > .product-payment-icons',
          ),
          ...Array.from(infoContainer.children).filter((item) => item.querySelector('product-form')),
        ]
      : [];

    [...new Set(actionElements)].forEach((item, index) => {
        addAos(item, 'vag-product-action', {
          duration: 640,
          delay: Math.min(index * 55, 220),
          offset: 35,
        });
      });
  }

  function annotateSharedSections(root = document) {
    root.querySelectorAll('.featured-collection-design').forEach((section) => {
      addAos(section.querySelector('.featured-collection-design__header'), 'vag-section-heading', {
        duration: 620,
        offset: 45,
      });
      section.querySelectorAll('.product-grid > .grid__item').forEach((card, index) => {
        addAos(card, 'vag-card-rise', {
          duration: 650,
          delay: Math.min((index % 4) * 60, 180),
          offset: 55,
        });
      });
    });

    root.querySelectorAll('.icon-benefits-bar__item').forEach((item, index) => {
      addAos(item, 'vag-section-pop', {
        duration: 540,
        delay: Math.min(index * 60, 180),
        offset: 30,
      });
    });

    root.querySelectorAll('.collector-testimonials').forEach((section) => {
      addAos(section.querySelector('.collector-testimonials__header'), 'vag-section-heading', {
        duration: 620,
        offset: 45,
      });
      addAos(section.querySelector('.collector-testimonials__viewport'), 'vag-section-right', {
        duration: 760,
        delay: 60,
        offset: 70,
      });
    });

    root.querySelectorAll('.image-icon-benefits').forEach((section) => {
      addAos(section.querySelector('.image-icon-benefits__media'), 'vag-section-left', {
        duration: 760,
        offset: 70,
      });
      addAos(section.querySelector('.image-icon-benefits__content'), 'vag-section-right', {
        duration: 760,
        delay: 70,
        offset: 70,
      });
    });

    root.querySelectorAll('faq-accordion.faq-accordion').forEach((section) => {
      addAos(section.querySelector('.faq__header, .faq-accordion__header, .title-wrapper-with-link'), 'vag-section-heading', {
        duration: 620,
        offset: 45,
      });
      section.querySelectorAll('.faq__item, .faq-accordion__item, .accordion').forEach((row, index) => {
        addAos(row, 'vag-faq-row', {
          duration: 560,
          delay: Math.min(index * 45, 180),
          offset: 35,
        });
      });
    });
  }

  function annotate(root = document) {
    annotateCollection(root);
    annotateProduct(root);
    annotateSharedSections(root);
  }

  function scheduleRefresh() {
    if (!window.AOS || refreshFrame) return;

    refreshFrame = requestAnimationFrame(() => {
      refreshFrame = null;
      window.AOS.refreshHard();
    });
  }

  function initializeAos() {
    if (!window.AOS || reducedMotion.matches || isDesignMode) return;

    annotate(document);
    document.documentElement.classList.add('page-motion-ready');
    window.AOS.init({
      once: true,
      mirror: false,
      offset: 65,
      duration: 700,
      easing: 'ease-out-cubic',
      anchorPlacement: 'top-bottom',
      disableMutationObserver: true,
      debounceDelay: 80,
      throttleDelay: 70,
    });

    const collection = document.querySelector('collection-component.collection-page-design');
    if (collection) {
      new MutationObserver(() => {
        annotateCollection(document);
        scheduleRefresh();
      }).observe(collection, { childList: true, subtree: true });
    }

    document.addEventListener('shopify:section:load', (event) => {
      annotate(event.target || document);
      scheduleRefresh();
    });
    window.addEventListener('load', scheduleRefresh, { once: true });
  }

  function initializeLenis() {
    if (!window.Lenis || reducedMotion.matches || !finePointer.matches || isDesignMode) return;

    const lenis = new window.Lenis({
      autoRaf: true,
      smoothWheel: true,
      lerp: 0.14,
      wheelMultiplier: 1,
      anchors: true,
      prevent: (node) =>
        Boolean(
          node?.closest?.(
            '[data-lenis-prevent], dialog, [role="dialog"], .menu-drawer, .cart-drawer, .predictive-search, .quick-add-modal, .facets__display',
          ),
        ),
    });

    const syncScrollLock = () => {
      const scrollLocked = Array.from(document.body.classList).some((className) =>
        className.startsWith('overflow-hidden'),
      );
      scrollLocked ? lenis.stop() : lenis.start();
    };

    new MutationObserver(syncScrollLock).observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });

    window.pageLenis = lenis;
  }

  initializeAos();
  initializeLenis();
})();
